import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import Article from 'src/smoothr-web-app-core/models/Article';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import Order from 'src/smoothr-web-app-core/models/Order';
import { numberD, numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-extra-option-article',
	templateUrl: './extra-option-article.component.html',
	styleUrl: './extra-option-article.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtraOptionArticleComponent {
	@Input() article: Article;
	@Input() articleGroup: ArticleGroup;
	@Input() count: number;
	@Input() order: Order;

	@Output() onRemoveEv = new EventEmitter<Article>();
	@Output() onAddEv = new EventEmitter<Article>();

	calculatePrice(article: Article) {
		return numberToCurrency(numberD(article.price), this.order.currency);
	}

	onRemove() {
		this.onRemoveEv.emit(this.article);
	}

	onAdd() {
		this.onAddEv.emit(this.article);
	}

	getCount(article: Article, articleGroup: ArticleGroup) {
		return articleGroup.groups.filter(ao => ao.article._id === article._id).reduce((prev, curr) => prev + curr.quantity, 0);
	}

}
